// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"335597f1","234":"4cd57dcc","589":"d3ad79da","666":"c6173d34","680":"580c1ff0","727":"3bdb2383","762":"ecbbae9f","794":"2fd989fb","973":"3d07351a"}[chunkId] + ".chunk.js";
};